import { motion } from "framer-motion";
import { Clock } from "lucide-react";

export const EASE = [0.16, 1, 0.3, 1];

export const FadeUp = ({ children, delay = 0, y = 26, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.75, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const ChapterHead = ({ num, label, title, lead }) => (
  <div className="chapter-head">
    <FadeUp>
      <p className="eyebrow">
        <span className="chapter-num">{num}</span>
        <span className="eyebrow-line" aria-hidden="true" />
        {label}
      </p>
    </FadeUp>
    <FadeUp delay={0.08}>
      <h2 className="h2 font-display">{title}</h2>
    </FadeUp>
    {lead && (
      <FadeUp delay={0.14}>
        <p className="lead">{lead}</p>
      </FadeUp>
    )}
  </div>
);

export const Soon = ({ text, testid = "placeholder-tag" }) => (
  <span className="soon-tag" data-testid={testid}>
    <Clock size={12} aria-hidden="true" />
    {text}
  </span>
);
